<template>

      <div >
        <svg
          v-if="preferencias.body == 'body'"
          viewBox="0 0 600 600"
          style="enable-background:new 0 0 600 600;"
          xml:space="preserve"
        >
          <path
            class="st0"
            :style="preferencias.color"
            d="M155,318.5l-18-19.7c0,0-47.7,51.9-25,139.9c20,77.7,69.3,34.7,53.2-11.7C149.1,380.5,155,318.5,155,318.5z"
          />
          <path
            class="st1"
            d="M165.2,426.9c-16.1-46.4-10.1-108.5-10.1-108.5l-27.2-6.9c-9,29.8,20.4,89.2,24.2,105.9s8.6,33.9,1.9,48
          c-6.7,14.1-28.3,4.9-28.3,4.9C148.2,500.1,178.2,464.6,165.2,426.9z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M459.5,302.2l-17.9,19.4c0,0,6.3,60.7-9.7,106.4c-15.8,45.6,33.7,87.4,53.3,11.2
          C507.5,352.8,459.5,302.2,459.5,302.2z"
          />
          <path
            class="st1"
            d="M441.6,321.6l17.9-19.4c0,0,48,50.6,25.7,137c-19.6,76.3-69.1,34.4-53.3-11.2
          C447.9,382.3,441.6,321.6,441.6,321.6z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M432,427.9c-3.5,11.5-3.9,22.5-1.1,31.7c3.8,12.4,19.6,14.6,21.9-0.1c0.9-5.5,2.9-18.3,0.1-26.5
          C448.3,419.6,436.7,412.9,432,427.9z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M235.6,424.8c0,0-9.1,116.4-26.1,124.3c-16.8,7.9-10.9,12.9,29.8,12.9s48.6-3.9,50.6-37.7s-10.3-87.8-10.3-87.8
          L235.6,424.8z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M389.1,549.1c-16.8-7.9-26.1-124.3-26.1-124.3l-44,11.5c0,0-12.3,54.1-10.3,87.8s10,37.7,50.6,37.7
          C400,562,406,557,389.1,549.1z"
          />
          <path
            class="st1"
            d="M281.5,515.9c-6.4,34.3-32.3,49.2-70.9,44.6c6.3,0.9,15.8,1.5,28.8,1.5c40.7,0,48.6-3.9,50.6-37.7
          c2-33.7-10.3-87.8-10.3-87.8l-44-11.6c0,0,7.2,7.1,22.5,13.8C273.6,445.4,287.9,481.7,281.5,515.9z"
          />
          <path
            class="st1"
            d="M364.3,493.4c3,33.3,25.7,70-19.8,68.3l0,0c4.4,0.2,9.3,0.3,14.9,0.3c40.7,0,46.6-5,29.8-12.9
          c-16.8-7.9-26.1-124.3-26.1-124.3L319,436.4c0,0,12.1,4,22.2,4C351.3,440.4,361.3,460.1,364.3,493.4z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M456.3,260.9c5.9,7.6,14.8,12.2,14.8,12.2c-3.2-37.3-51.9-79.8-51.9-79.8c16.4,5.7,16.6,0.4,16.6,0.4
          c-47.6-48.2-103-45.1-103-45.1c5.7-0.4,9.6-7.6,9.6-7.6c-23.6-7.8-43.3,4.1-43.3,4.1s-23.3-6.3-31.8-17.9c0,0-7.4,14.8,6.3,22.2
          c0,0-28.6-11.7-65.6,5.3c0,0,10.6,7.4,22.2,7.4c0,0-51.8,1.1-91.1,59.3c0,0,8,2.2,16.1-2.9c-9.4,9.7-26,30.5-30.4,60.1
          c0,0,6.3-1.1,10.9-8.3c-5.7,14.1-15.5,48.7-1.9,94.9c0,0,4.1-0.4,5-20.4c0,0,11.3,76,54.2,108.6c0,0,5.2-9.6-0.9-23.9
          c0,0,27.9,26.2,31.1,43.7c0,0,6.1-10.7,1.9-22c0,0,23.5,17,72.8,17s77.4-19.4,77.4-19.4c-2.8,9.7,5.9,19.4,5.9,19.4
          c0.8-16.1,22.4-38.7,22.4-38.7c-8.2,7.5-1,23-1,23c15.5-13.1,26.3-38.9,31.1-52.2c-1.1,9.3,4.7,15.7,4.7,15.7
          c20.7-22.2,19.6-76.3,19.6-76.3c1.4,13.4,12.9,24.7,12.9,24.7C480.6,314.5,456.3,260.9,456.3,260.9z"
          />
          <path
            class="st2"
            d="M192.2,429.6c0,0,27.9,26.2,31.1,43.7c0,0,6.1-10.7,1.9-22c0,0,23.5,17,72.8,17s77.4-19.4,77.4-19.4
          c-2.8,9.7,5.9,19.4,5.9,19.4c0.8-16.1,22.4-38.7,22.4-38.7c-8.2,7.5-1,23-1,23c15.5-13.1,26.3-38.9,31.1-52.2
          c-1.1,9.3,4.7,15.7,4.7,15.7c20.7-22.2,19.6-76.3,19.6-76.3c1.4,13.4,12.9,24.7,12.9,24.7c9.6-50-14.8-103.5-14.8-103.5
          c5.9,7.6,14.8,12.2,14.8,12.2c-3.2-37.3-51.9-79.8-51.9-79.8c16.4,5.7,16.6,0.4,16.6,0.4c-47.6-48.2-103-45.2-103-45.2
          s5.7-0.7,12.7,7.2c7,7.8,15.4,18.8,32.6,24.5c17.3,5.7,60,27.6,72.4,63.1c0,0-10.2-3.1-14.8-9.3c0,0,37.8,76.1,9.8,147.1
          c0,0-6.8-7.2-5.5-17.1c0,0-29.3,84.4-130.2,93C228.6,464.1,192.2,429.6,192.2,429.6z"
          />
        </svg>

        <svg
          v-if="preferencias.body == 'body2'"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 600 600"
          style="enable-background:new 0 0 600 600;"
          xml:space="preserve"
        >
          <path
            class="st0"
            :style="preferencias.color"
            d="M200.6,425.6c0,0-5.7,119.9-16.3,128.1c-10.6,8.2-6.8,13.3,18.7,13.3s30.4-4,31.6-38.8
            c1.3-34.7-6.5-90.5-6.5-90.5L200.6,425.6z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M415.7,553.6c-10.6-8.2-16.3-128.1-16.3-128.1l-27.6,12.1c0,0-7.7,55.8-6.5,90.5c1.3,34.7,6.2,38.8,31.6,38.8
            C422.5,566.8,426.2,561.7,415.7,553.6z"
          />
          <path
            class="st1"
            d="M229.4,519.3c-4,35.3-20.1,50.7-44.4,46c3.9,1,9.8,1.5,18,1.5c25.5,0,30.4-4,31.6-38.8
            c1.3-34.7-6.5-90.5-6.5-90.5l-27.5-12c0,0,4.6,7.2,14.1,14.2C224.4,446.8,233.3,484.1,229.4,519.3z"
          />
          <path
            class="st1"
            d="M400.1,496.2c1.8,34.5,16.1,72.1-12.4,70.4l0,0c2.8,0.2,5.8,0.4,9.4,0.4c25.5,0,29.2-5.2,18.7-13.3
            c-10.6-8.2-16.3-128.1-16.3-128.1l-27.6,12c0,0,7.6,4.1,13.9,4.1C392,441.6,398.2,461.8,400.1,496.2z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M256.9,425.4c0,0-5.7,119.9-16.3,128.1c-10.6,8.2-6.8,13.3,18.7,13.3c25.5,0,30.4-4,31.6-38.8
            c1.3-34.7-6.5-90.5-6.5-90.5L256.9,425.4z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M357.3,553.4c-10.6-8.2-16.3-128.1-16.3-128.1l-27.6,12.1c0,0-7.7,55.8-6.5,90.5c1.3,34.7,6.2,38.8,31.6,38.8
            C364.1,566.7,367.8,561.6,357.3,553.4z"
          />
          <path
            class="st1"
            d="M285.8,519.1c-4,35.3-20.1,50.7-44.4,46c3.9,1,9.8,1.5,18,1.5c25.5,0,30.4-4,31.6-38.8
            c1.3-34.7-6.5-90.5-6.5-90.5l-27.5-12c0,0,4.6,7.2,14.1,14.2C280.7,446.6,289.7,483.9,285.8,519.1z"
          />
          <path
            class="st1"
            d="M341.7,496c1.8,34.5,16.1,72.1-12.4,70.4l0,0c2.8,0.2,5.8,0.4,9.4,0.4c25.5,0,29.2-5.2,18.7-13.3
            s-16.3-128.1-16.3-128.1l-27.5,12c0,0,7.6,4.1,13.9,4.1C333.6,441.5,339.9,461.7,341.7,496z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M155,318.5l-18-19.7c0,0-47.7,51.9-25,139.9c20,77.7,69.3,34.7,53.2-11.7C149.1,380.5,155,318.5,155,318.5z"
          />
          <path
            class="st1"
            d="M165.2,426.9c-16.1-46.4-10.1-108.5-10.1-108.5l-27.2-6.9c-9,29.8,20.4,89.2,24.2,105.9s8.6,33.9,1.9,48
            c-6.7,14.1-28.3,4.9-28.3,4.9C148.2,500.1,178.2,464.6,165.2,426.9z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M459.5,302.2l-17.9,19.4c0,0,6.3,60.7-9.7,106.4c-15.8,45.6,33.7,87.4,53.3,11.2
            C507.5,352.8,459.5,302.2,459.5,302.2z"
          />
          <path
            class="st1"
            d="M441.6,321.6l17.9-19.4c0,0,48,50.6,25.7,137c-19.6,76.3-69.1,34.4-53.3-11.2
            C447.9,382.3,441.6,321.6,441.6,321.6z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M432,427.9c-3.5,11.5-3.9,22.5-1.1,31.7c3.8,12.4,19.6,14.6,21.9-0.1c0.9-5.5,2.9-18.3,0.1-26.5
            C448.3,419.6,436.7,412.9,432,427.9z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M456.3,260.9c5.9,7.6,14.8,12.2,14.8,12.2c-3.2-37.3-51.9-79.8-51.9-79.8c16.4,5.7,16.6,0.4,16.6,0.4
            c-47.6-48.2-103-45.1-103-45.1c5.7-0.4,9.6-7.6,9.6-7.6c-23.6-7.8-43.3,4.1-43.3,4.1s-23.3-6.3-31.8-17.9c0,0-7.4,14.8,6.3,22.2
            c0,0-28.6-11.7-65.6,5.3c0,0,10.6,7.4,22.2,7.4c0,0-51.8,1.1-91.1,59.3c0,0,8,2.2,16.1-2.9c-9.4,9.7-26,30.5-30.4,60.1
            c0,0,6.3-1.1,10.9-8.3c-5.7,14.1-15.5,48.7-1.9,94.9c0,0,4.1-0.4,5-20.4c0,0,11.3,76,54.2,108.6c0,0,5.2-9.6-0.9-23.9
            c0,0,27.9,26.2,31.1,43.7c0,0,6.1-10.7,1.9-22c0,0,23.5,17,72.8,17s77.4-19.4,77.4-19.4c-2.8,9.7,5.9,19.4,5.9,19.4
            c0.8-16.1,22.4-38.7,22.4-38.7c-8.2,7.5-1,23-1,23c15.5-13.1,26.3-38.9,31.1-52.2c-1.1,9.3,4.7,15.7,4.7,15.7
            c20.7-22.2,19.6-76.3,19.6-76.3c1.4,13.4,12.9,24.7,12.9,24.7C480.6,314.5,456.3,260.9,456.3,260.9z"
          />
          <path
            class="st2"
            d="M192.2,429.6c0,0,27.9,26.2,31.1,43.7c0,0,6.1-10.7,1.9-22c0,0,23.5,17,72.8,17s77.4-19.4,77.4-19.4
            c-2.8,9.7,5.9,19.4,5.9,19.4c0.8-16.1,22.4-38.7,22.4-38.7c-8.2,7.5-1,23-1,23c15.5-13.1,26.3-38.9,31.1-52.2
            c-1.1,9.3,4.7,15.7,4.7,15.7c20.7-22.2,19.6-76.3,19.6-76.3c1.4,13.4,12.9,24.7,12.9,24.7c9.6-50-14.8-103.5-14.8-103.5
            c5.9,7.6,14.8,12.2,14.8,12.2c-3.2-37.3-51.9-79.8-51.9-79.8c16.4,5.7,16.6,0.4,16.6,0.4c-47.6-48.2-103-45.2-103-45.2
            s5.7-0.7,12.7,7.2c7,7.8,15.4,18.8,32.6,24.5c17.3,5.7,60,27.6,72.4,63.1c0,0-10.2-3.1-14.8-9.3c0,0,37.8,76.1,9.8,147.1
            c0,0-6.8-7.2-5.5-17.1c0,0-29.3,84.4-130.2,93C228.6,464.1,192.2,429.6,192.2,429.6z"
          />
        </svg>

        <svg
          v-if="preferencias.body == 'body3'"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 600 600"
          style="enable-background:new 0 0 600 600;"
          xml:space="preserve"
        >
          <path
            class="st0"
            :style="preferencias.color"
            d="M165.9,318.2l-5.4-26.1c0,0-67.6,20.1-93.2,107.3c-22.7,77,41.7,65.3,51.7,17.2
                C129,368.4,165.9,318.2,165.9,318.2z"
          />
          <path
            class="st1"
            d="M119.1,416.5c10-48.1,46.9-98.3,46.9-98.3l-19.8-19.9c-23,21-28.2,87-33.5,103.3c-5.3,16.3-10,33.5-23,42.2
                c-13,8.7-26.8-10.3-26.8-10.3C66.9,470.6,110.9,455.5,119.1,416.5z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M438.2,284.4l-7,25.4c0,0,33.4,51.1,40.1,99.1c6.8,47.8,70,62.3,52.5-14.5C504,307.4,438.2,284.4,438.2,284.4z"
          />
          <path
            class="st1"
            d="M431.2,309.8l7-25.4c0,0,65.8,23,85.6,110.1c17.5,76.8-45.7,62.2-52.5,14.5
                C464.5,360.9,431.2,309.8,431.2,309.8z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M479.9,414.7c3.6,11.4,9.6,20.8,17.1,26.7c10.2,8.1,24.4,0.9,18-12.5c-2.4-5-8-16.7-14.9-21.8
                C488.6,398.6,475.3,399.7,479.9,414.7z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M245.4,465c0,0-7,85.4-19.8,91.2c-12.9,5.8-8.3,9.5,22.7,9.5s37.1-2.9,38.6-27.7c1.5-24.7-7.8-64.5-7.8-64.5
                L245.4,465z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M371.6,556.2c-12.9-5.8-19.8-91.2-19.8-91.2l-33.6,8.5c0,0-9.3,39.7-7.8,64.5c1.5,24.7,7.6,27.7,38.6,27.7
                S384.5,562.1,371.6,556.2z"
          />
          <path
            class="st1"
            d="M280.4,531.8c-4.9,25.2-24.6,36.1-54.2,32.8c4.8,0.7,12,1.1,21.9,1.1c31.1,0,37.1-2.9,38.6-27.7
                c1.5-24.7-7.8-64.5-7.8-64.5l-33.6-8.5c0,0,5.4,5.2,17.2,10.1C274.3,480.1,285.3,506.7,280.4,531.8z"
          />
          <path
            class="st1"
            d="M352.7,515.4c2.3,24.5,19.7,51.3-15.2,50.2l0,0c3.3,0.2,7.1,0.3,11.4,0.3c31.1,0,35.6-3.6,22.7-9.5
                c-12.9-5.8-19.8-91.2-19.8-91.2l-33.6,8.4c0,0,9.2,3,16.9,3C342.8,476.5,350.4,490.9,352.7,515.4z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M479,401.7c-8.9-46.4-30.4-99.6-37.9-117.5c5.7,8.1,17.8,11.7,17.8,11.7c-7.7-56.6-37.3-109.4-37.3-109.4
                c7.6,12.7,22.7,14,22.7,14c-17.6-49.2-48-47.9-48-47.9c13.3-12.1,4.4-31.1,4.4-31.1c-8.6,22.3-40.9,25.4-40.9,25.4H240.2
                c0,0-32.2-3-40.9-25.4c0,0-8.9,19,4.4,31.1c0,0-30.4-1.3-48,47.9c0,0,15.1-1.3,22.7-14c0,0-29.6,52.8-37.3,109.4
                c0,0,12.1-3.5,17.8-11.7c-7.5,17.8-29.1,71.1-37.9,117.5c0,0,9.6-1.2,16.2-8.3c-7.8,17.9-19.7,55.3-3.9,91.2c0,0,9.5-5,8.6-20.9
                c0.3,6,0.8,15.8,0.8,15.8s10.5,19,30.8,22c0,0-4.1-8.2-7.4-19.8l0,0c5.3,1.9,11,2.9,17,2.9H417c6,0,11.8-1.1,17-2.9l0,0
                c-3.2,11.6-7.4,19.8-7.4,19.8c20.3-3,30.8-22,30.8-22s0.5-9.9,0.8-15.8c-0.8,15.8,8.6,20.9,8.6,20.9c15.8-36,3.9-73.3-3.9-91.2
                C469.4,400.4,479,401.7,479,401.7z"
          />
          <path
            class="st2"
            d="M166,481.7c5.3,1.9,11,2.9,17,2.9h233.9c6,0,11.8-1.1,17-2.9l0,0c-3.2,11.6-7.4,19.8-7.4,19.8
                c20.3-3,30.8-22,30.8-22s0.5-9.9,0.8-15.8c-0.8,15.8,8.6,20.9,8.6,20.9c15.8-36,3.9-73.3-3.9-91.2c6.5,7.1,16.2,8.3,16.2,8.3
                c-8.9-46.4-30.4-99.6-37.9-117.5c5.7,8.1,17.8,11.7,17.8,11.7c-7.7-56.6-37.3-109.4-37.3-109.4c7.6,12.7,22.7,14,22.7,14
                c-17.6-49.2-48-47.9-48-47.9c13.3-12.1,4.4-31.1,4.4-31.1c-8.6,22.3-40.9,25.4-40.9,25.4H240.2c0,0,124.4-5.9,164.2,23.8
                c0,0-12.3,4.5-22.4,1.5c0,0,67.3,92.4,78.2,203.6c0,0-13-5.4-18.9-15.8c0,0,25.2,80.5,2.4,121.2c0,0-6.5-11.7-9.6-25.1
                C434,456.1,398.5,485.8,166,481.7z"
          />
        </svg>

        <svg
          v-if="preferencias.body == 'body4'"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 600 600"
          style="enable-background:new 0 0 600 600;"
          xml:space="preserve"
        >
          <path
            class="st0"
            :style="preferencias.color"
            d="M165.9,318.2l-5.4-26.1c0,0-67.6,20.1-93.2,107.3c-22.7,77,41.7,65.3,51.7,17.2
              C129,368.4,165.9,318.2,165.9,318.2z"
          />
          <path
            class="st1"
            d="M119.1,416.5c10-48.1,46.9-98.3,46.9-98.3l-19.8-19.9c-23,21-28.2,87-33.5,103.3c-5.3,16.3-10,33.5-23,42.2
              c-13,8.7-26.8-10.3-26.8-10.3C66.9,470.6,110.9,455.5,119.1,416.5z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M438.2,284.4l-7,25.4c0,0,33.4,51.1,40.1,99.1c6.8,47.8,70,62.3,52.5-14.5C504,307.4,438.2,284.4,438.2,284.4z"
          />
          <path
            class="st1"
            d="M431.2,309.8l7-25.4c0,0,65.8,23,85.6,110.1c17.5,76.8-45.7,62.2-52.5,14.5
              C464.5,360.9,431.2,309.8,431.2,309.8z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M479.9,414.7c3.6,11.4,9.6,20.8,17.1,26.7c10.2,8.1,24.4,0.9,18-12.5c-2.4-5-8-16.7-14.9-21.8
              C488.6,398.6,475.3,399.7,479.9,414.7z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M245.4,465c0,0-7,85.4-19.8,91.2c-12.9,5.8-8.3,9.5,22.7,9.5s37.1-2.9,38.6-27.7c1.5-24.7-7.8-64.5-7.8-64.5
              L245.4,465z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M371.6,556.2c-12.9-5.8-19.8-91.2-19.8-91.2l-33.6,8.5c0,0-9.3,39.7-7.8,64.5c1.5,24.7,7.6,27.7,38.6,27.7
              S384.5,562.1,371.6,556.2z"
          />
          <path
            class="st1"
            d="M280.4,531.8c-4.9,25.2-24.6,36.1-54.2,32.8c4.8,0.7,12,1.1,21.9,1.1c31.1,0,37.1-2.9,38.6-27.7
              c1.5-24.7-7.8-64.5-7.8-64.5l-33.6-8.5c0,0,5.4,5.2,17.2,10.1C274.3,480.1,285.3,506.7,280.4,531.8z"
          />
          <path
            class="st1"
            d="M352.7,515.4c2.3,24.5,19.7,51.3-15.2,50.2l0,0c3.3,0.2,7.1,0.3,11.4,0.3c31.1,0,35.6-3.6,22.7-9.5
              c-12.9-5.8-19.8-91.2-19.8-91.2l-33.6,8.4c0,0,9.2,3,16.9,3C342.8,476.5,350.4,490.9,352.7,515.4z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M466.8,398.8c-9.7-45.7,26.2-108.2,18-125.9c6.2,8,19.4,11.5,19.4,11.5c-8.4-55.8-40.6-107.8-40.6-107.8
              c8.3,12.5,24.7,13.9,24.7,13.9C469.1,142,436,143.4,436,143.4c14.5-11.9,4.8-30.6,4.8-30.6c-9.4,22-44.5,24.9-44.5,24.9H192.6
              c0,0-35.1-2.9-44.5-24.9c0,0-9.7,18.7,4.8,30.6c0,0-33.1-1.4-52.3,47.2c0,0,16.4-1.4,24.7-13.9c0,0-32.2,52.1-40.6,107.8
              c0,0,13.2-3.4,19.4-11.5c-8.2,17.6,33.3,80.1,23.7,125.9c0,0,10.5-1.2,17.6-8.2c-8.5,17.7-21.4,54.5-4.2,89.9c0,0,10.3-4.9,9.4-20.6
              c0.3,5.9,0.9,15.6,0.9,15.6s11.4,18.7,33.5,21.6c0,0-4.5-8.1-8.1-19.5l0,0c5.8,1.8,12,2.8,18.5,2.8h204c6.5,0,12.8-1.1,18.5-2.8l0,0
              c-3.5,11.4-8.1,19.5-8.1,19.5c22.1-2.9,33.5-21.6,33.5-21.6s0.5-9.7,0.9-15.6c-0.9,15.6,9.4,20.6,9.4,20.6
              c17.2-35.4,4.3-72.2-4.2-89.9C456.3,397.6,466.8,398.8,466.8,398.8z"
          />
          <path
            class="st2"
            d="M282.8,480.6c4.5,0,75.4,0.9,114,0c17.4-0.4,19.3-2.3,21-2.8c-3.5,11.4-8.1,19.5-8.1,19.5
              c22.1-2.9,33.5-21.6,33.5-21.6s0.5-9.7,0.9-15.6c-0.9,15.6,9.4,20.6,9.4,20.6c17.2-35.4,4.3-72.2-4.2-89.9c7,7,17.5,8.2,17.5,8.2
              c-9.7-45.7,26.2-108.2,18-125.9c6.2,8,19.4,11.5,19.4,11.5c-8.4-55.8-40.6-107.8-40.6-107.8c8.3,12.5,24.7,13.9,24.7,13.9
              c-19.2-48.5-52.3-47.2-52.3-47.2c14.5-11.9,4.8-30.6,4.8-30.6c-9.4,22-44.5,24.9-44.5,24.9H192.6c0,0,305.3,4.1,239.7,38.3
              c0,0,57.8,68.5,49.8,85l-32.8,111.9l-14.2-8.8c0,0,21.5,65.5,6.9,80.4C411.6,479.6,282.8,480.6,282.8,480.6z"
          />
        </svg>

        <svg
          v-if="preferencias.body == 'body5'"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 600 600"
          style="enable-background:new 0 0 600 600;"
          xml:space="preserve"
        >
          <path
            class="st0"
            :style="preferencias.color"
            d="M165.9,318.2l-5.4-26.1c0,0-67.6,20.1-93.2,107.3c-22.7,77,41.7,65.3,51.7,17.2
            C129,368.4,165.9,318.2,165.9,318.2z"
          />
          <path
            class="st1"
            d="M119.1,416.5c10-48.1,46.9-98.3,46.9-98.3l-19.8-19.9c-23,21-28.2,87-33.5,103.3c-5.3,16.3-10,33.5-23,42.2
            c-13,8.7-26.8-10.3-26.8-10.3C66.9,470.6,110.9,455.5,119.1,416.5z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M438.2,284.4l-7,25.4c0,0,33.4,51.1,40.1,99.1c6.8,47.8,70,62.3,52.5-14.5C504,307.4,438.2,284.4,438.2,284.4z"
          />
          <path
            class="st1"
            d="M431.2,309.8l7-25.4c0,0,65.8,23,85.6,110.1c17.5,76.8-45.7,62.2-52.5,14.5
            C464.5,360.9,431.2,309.8,431.2,309.8z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M479.9,414.7c3.6,11.4,9.6,20.8,17.1,26.7c10.2,8.1,24.4,0.9,18-12.5c-2.4-5-8-16.7-14.9-21.8
            C488.6,398.6,475.3,399.7,479.9,414.7z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M245.4,465c0,0-7,85.4-19.8,91.2c-12.9,5.8-8.3,9.5,22.7,9.5s37.1-2.9,38.6-27.7c1.5-24.7-7.8-64.5-7.8-64.5
            L245.4,465z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M371.6,556.2c-12.9-5.8-19.8-91.2-19.8-91.2l-33.6,8.5c0,0-9.3,39.7-7.8,64.5c1.5,24.7,7.6,27.7,38.6,27.7
            S384.5,562.1,371.6,556.2z"
          />
          <path
            class="st1"
            d="M280.4,531.8c-4.9,25.2-24.6,36.1-54.2,32.8c4.8,0.7,12,1.1,21.9,1.1c31.1,0,37.1-2.9,38.6-27.7
            c1.5-24.7-7.8-64.5-7.8-64.5l-33.6-8.5c0,0,5.4,5.2,17.2,10.1C274.3,480.1,285.3,506.7,280.4,531.8z"
          />
          <path
            class="st1"
            d="M352.7,515.4c2.3,24.5,19.7,51.3-15.2,50.2l0,0c3.3,0.2,7.1,0.3,11.4,0.3c31.1,0,35.6-3.6,22.7-9.5
            c-12.9-5.8-19.8-91.2-19.8-91.2l-33.6,8.4c0,0,9.2,3,16.9,3C342.8,476.5,350.4,490.9,352.7,515.4z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M435.3,231.2c5.1,6.5,12.6,10.4,12.6,10.4s0,0,0-0.1c-2.8-31.7-44.3-67.7-44.3-67.7s0.1,0,0.2,0
            c13.8,4.7,14,0.3,14,0.3c-37-37.3-79.5-38.5-86.9-38.4c-0.6,0-1,0-1,0c0.2,0,0.4,0,0.6-0.1c0,0,0.1,0,0.1,0c4.4-0.8,7.4-6.3,7.4-6.3
            c-20.2-6.6-37,3.5-37,3.5s-19.9-5.3-27.2-15.2c0,0-6.3,12.5,5.4,18.9c-0.9-0.3-24.9-9.6-56.1,4.5c0,0,9,6.3,19,6.3
            c0,0-44.3,0.9-77.8,50.4c0,0,6.8,1.9,13.7-2.5c-8,8.3-22.2,26-25.9,51.1c0,0,5.4-1,9.3-7.1c-1.8,4.6-8.6,24.2-15.5,48.8
            c2.3,2.3,4.2,4.3,5.6,5.7c-0.4-0.4-0.9-0.9-1.4-1.3c-1.2-1.2-2.7-2.6-4.2-4.3c-0.1,0.3-0.2,0.6-0.3,0.9c-1,3.4-1.9,6.9-2.9,10.4
            c-1,3.7-2,7.5-2.9,11.4c-8.8,35.4-15.7,74.4-9.8,94.3c0,0,3.5-0.3,4.3-17.4c0,0,9.6,64.6,46.3,92.3c0,0,4.5-8.1-0.8-20.3
            c0.8,0.3,49.9,22.4,52.7,37.1c0,0,5.2-9,1.7-18.6c0.5,0.3,6.6,4.5,18.6,8.3c0.4,0.1,0.9,0.3,1.3,0.4c0.9,0.3,1.8,0.5,2.8,0.8
            c0.5,0.1,1,0.3,1.6,0.4c1.1,0.3,2.3,0.5,3.4,0.8c0.4,0.1,0.9,0.2,1.3,0.3c0.4,0.1,1,0.2,1.4,0.3c0.4,0.1,1,0.2,1.4,0.3
            c0.4,0.1,1,0.2,1.4,0.3c1.1,0.2,2.3,0.4,3.5,0.6c0.8,0.1,1.6,0.2,2.4,0.4c0.6,0.1,1.1,0.2,1.7,0.2c0.6,0.1,1.2,0.1,1.8,0.2
            c0.7,0.1,1.5,0.2,2.2,0.2c0.3,0,0.7,0.1,1.1,0.1c1,0.1,2,0.2,3,0.3c0.6,0,1.2,0.1,1.7,0.1c0.6,0,1.2,0.1,1.8,0.1
            c0.9,0,1.8,0.1,2.7,0.1c0.6,0,1.3,0,1.9,0.1c0.4,0,0.8,0,1.2,0c0.4,0,0.8,0,1.2,0c0.8,0,1.6,0,2.4,0c1,0,2,0,2.9,0
            c0.6,0,1.2,0,1.7,0c1,0,2-0.1,3-0.1c0.7,0,1.5-0.1,2.2-0.1c0.3,0,0.4,0,0.7,0c0.7,0,1.4-0.1,2.2-0.2c0.4,0,1-0.1,1.4-0.1
            c1-0.1,1.9-0.2,2.8-0.3c1.4-0.2,2.7-0.3,4.1-0.5c0.5-0.1,1-0.1,1.5-0.2c0.5-0.1,1-0.2,1.5-0.2c1.5-0.2,2.9-0.5,4.2-0.7
            c1.4-0.3,2.7-0.5,4-0.8c1.4-0.3,2.7-0.6,4-0.9c1.2-0.3,2.4-0.6,3.5-0.9c0.6-0.2,1.1-0.3,1.7-0.5c0.5-0.2,1.1-0.3,1.6-0.5
            c0.4-0.1,1-0.3,1.4-0.4c0.9-0.3,1.6-0.5,2.4-0.8c1-0.3,1.8-0.6,2.7-1c0.4-0.2,0.8-0.3,1.2-0.5c0.4-0.1,0.8-0.3,1.1-0.5
            c0.6-0.2,1.1-0.5,1.7-0.7c0.5-0.2,1.1-0.5,1.6-0.7c7.2-3.1,11-5.8,11-5.8s0,0,0,0.1c-2.3,8.3,5,16.5,5,16.5s0,0,0-0.1
            c0.9-13.7,46-32.8,46-32.8l25.7-24.9c0,0.1,0,0.2,0,0.3c-0.8,7.8,4.1,13.1,4.1,13.1c17.7-19,16.7-64.9,16.7-64.9
            c0,0.2,0,0.4,0.1,0.6c1.5,11.1,10.9,20.4,10.9,20.4s0,0,0-0.1C479.2,362,435.9,233,435.3,231.2z M417.7,208.4
            c3.8,5,11.7,7.6,12.6,7.9c0,0,0,0,0,0c0,0-8.4-2.5-12.6-7.7C417.7,208.5,417.7,208.4,417.7,208.4z M306.6,483.1l-72.1-4.9
            c-0.1-0.1-0.2-0.1-0.2-0.1c0,0,0.1,0.1,0.2,0.1l-0.1,0c0,0,0-0.1,0-0.1L306.6,483.1c86.2-7.4,138-79.1,138-79.1c0,0,0,0.1,0,0.1
            C444.2,404.7,392.4,475.9,306.6,483.1z M444.5,405.6c-0.2,7.5,4.8,12.9,4.8,12.9c1.8-4.6,3.2-9.7,4.2-15.3c-1,5.6-2.3,10.8-4.2,15.4
            C449.3,418.6,444.2,413.2,444.5,405.6z"
          />
          <path
            class="st2"
            d="M413.6,459.9c0,0-45.4,19.1-46,32.8c0,0,0,0-0.1-0.1c-0.7-0.8-7.2-8.6-5-16.5c0,0,0,0-0.1,0.1
            c-0.6,0.4-4.3,2.8-11,5.7c-0.5,0.2-1,0.5-1.6,0.7s-1.1,0.5-1.7,0.7c-0.3,0.2-0.8,0.3-1.1,0.5s-0.8,0.3-1.2,0.5
            c-0.9,0.3-1.7,0.7-2.7,1c-0.8,0.3-1.6,0.5-2.4,0.8c-0.4,0.2-1,0.3-1.4,0.4c-0.5,0.2-1.1,0.3-1.6,0.5c-0.6,0.2-1.1,0.3-1.7,0.5
            c-1.1,0.3-2.3,0.6-3.5,0.9c-1.3,0.3-2.6,0.7-4,0.9c-1.3,0.3-2.6,0.6-4,0.8c-1.4,0.3-2.8,0.5-4.2,0.7c-0.5,0.1-1,0.2-1.5,0.2
            c-0.5,0-1,0.1-1.5,0.2c-1.3,0.2-2.7,0.3-4.1,0.5c-0.9,0.1-1.8,0.2-2.8,0.3c-0.4,0-1,0.1-1.4,0.1c-0.7,0.1-1.4,0.1-2.2,0.2
            c-0.3,0-0.4,0-0.7,0c-0.7,0-1.5,0.1-2.2,0.1c-1,0-2,0.1-3,0.1c-0.6,0-1.2,0-1.7,0c-1,0-1.9,0-2.9,0c-0.9,0-1.6,0-2.4,0
            c-0.4,0-0.8,0-1.2,0s-0.8,0-1.2,0c-0.7,0-1.3,0-1.9-0.1c-0.9,0-1.8-0.1-2.7-0.1c-0.6,0-1.2-0.1-1.8-0.1s-1.2-0.1-1.7-0.1
            c-1-0.1-2.1-0.2-3-0.3c-0.3,0-0.7-0.1-1.1-0.1c-0.8-0.1-1.5-0.1-2.2-0.2c-0.6-0.1-1.2-0.1-1.8-0.2c-0.6-0.1-1.2-0.2-1.7-0.2
            c-0.8-0.1-1.6-0.2-2.4-0.4c-1.2-0.2-2.4-0.4-3.5-0.6c-0.4-0.1-1-0.2-1.4-0.3c-0.4-0.1-1-0.2-1.4-0.3c-0.4-0.1-1-0.2-1.4-0.3
            c-0.4-0.1-0.9-0.2-1.3-0.3c-1.1-0.3-2.3-0.5-3.4-0.8c-0.5-0.1-1.1-0.3-1.6-0.4c-1-0.3-1.9-0.5-2.8-0.8c-0.4-0.1-0.9-0.3-1.3-0.4
            c-12.5-3.9-18.7-8.3-18.7-8.3l72.3,4.9c86.2-7.3,138-79,138-79c-1.1,8.4,4.7,14.5,4.7,14.5c23.8-59.9-31-208.3-31.7-210.2
            c4.1,5.3,12.7,7.9,12.7,7.9c-10.6-30.2-47.2-48.8-61.9-53.7c-14.8-4.9-21.9-14.2-27.9-20.8c-4.2-4.8-8-5.9-9.7-6.1l0,0l0,0
            c-0.2,0-0.3,0-0.5-0.1l0,0c-0.1,0-0.2,0-0.3,0c0.1,0,0.3,0,0.3,0l0,0c5.9-0.1,49.5,0.3,87.3,38.4c0,0,0,0,0,0.1
            c-0.1,0.5-1.1,4.1-14.2-0.4c0,0,0,0,0.2,0.1l0,0c2.7,2.4,41.6,37.1,44.2,67.7l0,0c-0.3-0.2-7.7-4-12.6-10.4c0,0,0,0,0,0.1l0,0
            c1.4,4.6,43.8,131.4,35.7,173.2l0,0c-0.9-0.9-9.9-10.1-11-21c0,0,0,0.2,0,0.6l0,0l0,0l0,0c0,5.5-0.3,46.7-16.8,64.3l0,0
            c-0.4-0.5-4.9-5.8-4-13.3c0,0.1-0.1,0.2-0.1,0.3l0,0"
          />
        </svg>

        <svg
          v-if="preferencias.body == 'body6'"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 600 600"
          style="enable-background:new 0 0 600 600;"
          xml:space="preserve"
        >
          <path
            class="st0"
            :style="preferencias.color"
            d="M165.9,318.2l-5.4-26.1c0,0-67.6,20.1-93.2,107.3c-22.7,77,41.7,65.3,51.7,17.2
            C129,368.4,165.9,318.2,165.9,318.2z"
          />
          <path
            class="st1"
            d="M119.1,416.5c10-48.1,46.9-98.3,46.9-98.3l-19.8-19.9c-23,21-28.2,87-33.5,103.3c-5.3,16.3-10,33.5-23,42.2
            c-13,8.7-26.8-10.3-26.8-10.3C66.9,470.6,110.9,455.5,119.1,416.5z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M438.2,284.4l-7,25.4c0,0,33.4,51.1,40.1,99.1c6.8,47.8,70,62.3,52.5-14.5C504,307.4,438.2,284.4,438.2,284.4z"
          />
          <path
            class="st1"
            d="M431.2,309.8l7-25.4c0,0,65.8,23,85.6,110.1c17.5,76.8-45.7,62.2-52.5,14.5
            C464.5,360.9,431.2,309.8,431.2,309.8z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M479.9,414.7c3.6,11.4,9.6,20.8,17.1,26.7c10.2,8.1,24.4,0.9,18-12.5c-2.4-5-8-16.7-14.9-21.8
            C488.6,398.6,475.3,399.7,479.9,414.7z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M245.4,465c0,0-7,85.4-19.8,91.2c-12.9,5.8-8.3,9.5,22.7,9.5s37.1-2.9,38.6-27.7c1.5-24.7-7.8-64.5-7.8-64.5
            L245.4,465z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M371.6,556.2c-12.9-5.8-19.8-91.2-19.8-91.2l-33.6,8.5c0,0-9.3,39.7-7.8,64.5c1.5,24.7,7.6,27.7,38.6,27.7
            S384.5,562.1,371.6,556.2z"
          />
          <path
            class="st1"
            d="M280.4,531.8c-4.9,25.2-24.6,36.1-54.2,32.8c4.8,0.7,12,1.1,21.9,1.1c31.1,0,37.1-2.9,38.6-27.7
            c1.5-24.7-7.8-64.5-7.8-64.5l-33.6-8.5c0,0,5.4,5.2,17.2,10.1C274.3,480.1,285.3,506.7,280.4,531.8z"
          />
          <path
            class="st1"
            d="M352.7,515.4c2.3,24.5,19.7,51.3-15.2,50.2l0,0c3.3,0.2,7.1,0.3,11.4,0.3c31.1,0,35.6-3.6,22.7-9.5
            c-12.9-5.8-19.8-91.2-19.8-91.2l-33.6,8.4c0,0,9.2,3,16.9,3C342.8,476.5,350.4,490.9,352.7,515.4z"
          />
          <path
            class="st0"
            :style="preferencias.color"
            d="M467.5,478.1c0-20.4-6.9-52.6-9.9-65.7c3,5.9,9.9,7.8,9.9,7.8c0.6-19.4-11.3-68.5-11.3-68.5c4,10,11,15,11,15
            c1.8-31.8-5.3-73.3-9.2-93.4c3.5,4.5,9.2,1.8,9.2,1.8c-1.8-53.4-16-80.2-23.3-90.5c7.7,7.5,15.6,5.8,15.6,5.8
            c-22-41.6-54.1-57.6-67.4-62.8c10.2,1.9,22.2-2.1,22.2-2.1c-34.5-26.2-76.7-19.1-76.7-19.1c-4.2-8.5,6.3-11,6.3-11
            c-25.4,0-42.8,6.2-44,6.9l0,0c-2.7,0-5.4,0.1-8,0.2c-10.3-0.3-28.1-2.6-37.5-14.5c0,0-6.7,13.2,7.9,18.5c0,0-42.2-7.2-76.7,19
            c0,0,12,3.9,22.2,2.1c-13.3,5.1-45.4,21.1-67.4,62.8c0,0,7.9,1.7,15.6-5.8c-7.3,10.3-21.5,37.1-23.3,90.5c0,0,5.8,2.7,9.2-1.8
            c-3.9,20.1-11,61.5-9.2,93.4c0,0,7-5,11-15c0,0-11.9,49.2-11.3,68.5c0,0,6.9-2,9.9-7.8c-3,13.1-9.9,45.3-9.9,65.7
            c0,0,5.9-6.9,11.3-14.4c0,0-10,29.9-5.8,51.7c0,0,13.3-6.2,16.1-18.4c0,0,4.2,15.2,13.3,18.4c0,0-6.3-18.4,15.4-18.4h234.8
            c21.7,0,15.4,18.4,15.4,18.4c9.1-3.1,13.3-18.4,13.3-18.4c2.8,12.1,16.1,18.4,16.1,18.4c4.2-21.8-5.8-51.7-5.8-51.7
            C461.6,471.2,467.5,478.1,467.5,478.1z"
          />
          <path
            class="st2"
            d="M182.5,497.1h234.8c21.7,0,15.4,18.4,15.4,18.4c9.1-3.1,13.3-18.4,13.3-18.4c2.8,12.1,16.1,18.4,16.1,18.4
            c4.2-21.8-5.8-51.7-5.8-51.7c5.4,7.5,11.3,14.4,11.3,14.4c0-20.4-6.9-52.6-9.9-65.7c3,5.9,9.9,7.8,9.9,7.8
            c0.6-19.4-11.3-68.5-11.3-68.5c4,10,11,15,11,15c1.8-31.8-5.3-73.3-9.2-93.4c3.5,4.5,9.2,1.8,9.2,1.8c-1.8-53.4-16-80.2-23.3-90.5
            c7.7,7.5,15.6,5.8,15.6,5.8c-22-41.6-54.1-57.6-67.4-62.8c10.2,1.9,22.2-2.1,22.2-2.1c-34.6-26.2-76.8-19.1-76.8-19.1
            s32.1-1,50.3,15.2c0,0-0.3,6.2-12.7,3.1c0,0,83.3,57.3,84,137.1c0,0-7,3.1-13.3-6.2c0,0,11.1,139.8,5.6,190.6c0,0-7-6.2-9.1-15.6
            c0,0,10.5,39.9-4.9,63c0,0-7.7-3.7-18.9-8.7C407.4,479.9,182.5,497.1,182.5,497.1z"
          />
        </svg>

    </div>
</template>

<script>


export default {
  name: "app",

  data() {
    return {


    };
  },
  methods: {

  },
  props: ["preferencias"],

  mounted: function() {

  }
};
</script>

<style scoped>
.st1 {
  opacity: 0.18;
  enable-background: new;
}
.st2 {
  opacity: 0.11;
  enable-background: new;
}

</style>


// WEBPACK FOOTER //
// src/components/shared/BodyArkidian.vue